import { render } from "./MonthPicker.vue?vue&type=template&id=2b5fbcb4&ts=true"
import script from "./MonthPicker.vue?vue&type=script&lang=ts"
export * from "./MonthPicker.vue?vue&type=script&lang=ts"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__